import styled from 'styled-components';

export const GroupHeader = styled.div`
  & > span {
    display: flex;
    color: ${props => props.theme.filter.groupTitleColor};
    font-size: ${props => props.theme.rem(14)};
    font-weight: 600;
    margin-right: ${props => props.theme.space(1)};
    ${({ theme }) => theme.gap(1)}

    strong {
      font-weight: 700;
    }
  }

  display: flex;
  align-items: center;
  margin-bottom: ${props => props.theme.space(3)};
`;

export const GroupContainer = styled.div`
  margin-bottom: ${props => props.theme.space(5)};

  > *:not(:first-child) {
    margin-bottom: ${props => props.theme.space(2)};
  }

  &:active,
  &:focus {
    outline: none;
  }
`;
